import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getForms } from 'api/Forms';

export const useForms = ({ params = {}, options = {}, dependencies = [] }) => {
  const navigate = useNavigate();
  return useQuery(['forms', ...dependencies], () => getForms(navigate, params), {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    staleTime: 1000 * 60 * 5,
    ...options
  });
};
